<div
  *ngIf="filters$ | async as filters"
  class="filters-container"
>

  <mojo-companies-sort-selector
    [sortBy]="filters.sortBy"
    (sortByChanged)="applyFilter({sortBy: $event})"
  >
  </mojo-companies-sort-selector>

  <button
    mat-raised-button
    color="primary"
    class="lg"
    (click)="submit()"
  >
    SHOW RESULTS ( {{ totalElements$ | async }} )
  </button>
  <mat-form-field
    color="accent"
    class=" width-220 companies"
  >
    <mat-icon matPrefix>
      search
    </mat-icon>
    <mat-label>Search companies
    </mat-label>
    <input
      [formControl]="searchCompanies"
      matInput
      type="text"
    />
  </mat-form-field>
</div>
